// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yF9IJ","text":"styles_text__qI57y","timer":"styles_timer__er9Bu"};